export class SetJobStatus {
    static readonly type = '[JobStatus] set';
    constructor(public data: any[]) { }
}
